// @flow
import * as React from 'react'
import { Typography } from '@material-ui/core'
import { Assignment, Info } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 20,
  },
  greyedOut: {
    color: theme.palette.text.greyedOut,
  },
}))

declare type Props = {
  variant: 'form' | 'info',
  text: string,
}

const NoData = ({ variant, text }: Props) => {
  const classes = useStyles()
  console.log(variant)
  const icon =
    variant === 'form' ? (
      <Assignment fontSize="inherit" color="inherit" />
    ) : (
      <Info fontSize="inherit" color="inherit" />
    )
  return (
    <div className={classes.root}>
      <Typography align="center" variant="h2" className={classes.greyedOut}>
        {icon}
      </Typography>
      <Typography align="center" className={classes.greyedOut}>
        {text}
      </Typography>
    </div>
  )
}

export default React.memo<Props>(NoData)
